import React from 'react'
import { Fragment, useRef, useState } from 'react'
import { BsPlusCircle, BsQuestionCircle } from 'react-icons/bs'
import { HiOutlineChevronDown } from 'react-icons/hi'
import { Dialog, Transition } from '@headlessui/react'
import { IoWarningOutline } from 'react-icons/io5'
import { FiEye, FiUpload } from "react-icons/fi"
import { FiEyeOff } from "react-icons/fi"
import FamilyPhotoCropper from '../../components/FamilyPhotoCropper/FamilyPhotoCropper'

const Documents = () => {
    const [documentNo, setDocumentNo] = useState<string>("");
    return (

        <>
        <div className="page-content-wraper">
                <div className="grid grid-cols-2 gap-4 mb-3">
                    <div><h1 className="page-title">Add Doucuments</h1></div>
                </div>
                <div className='bg-white rounded-lg py-3 px-4 shadow-md mb-5'>
                    <h4 className='mb-3 font-semibold text-lg'>Document Information </h4>
                    <div className="grid grid-cols-3 gap-4 form-style">
                    <div className="mb-2">
                    <label className="label"> Document Type <span className="text-red-600">*</span></label>
                    <select className='form-control'>
                    <option>Select Option</option>
                    <option>PAN</option>
                    <option>AADHAR</option>
                    <option>Driver's License</option>
                    <option>Passport</option>
                    <option>Policy Document</option>
                    <option>Vehcile RC</option>
                    <option>Payslip</option>
                    <option>Offer Letter</option>
                    <option>Salary Revision Letter</option>
                    <option>Cancelled Cheque</option>
                    <option>Fixed Deposit Receipt</option>
                    <option>Recurring Deposit Statement/Passbook</option>
                    <option>Postal Savings Schemes</option>
                    <option>PPF passbook</option>
                    <option>SSY passbook</option>
                    <option>Bond Certificate</option>
                    <option>EPF Statement</option>
                    <option>NPS Statement</option>
                    <option>Superannuation</option>
                    <option>Loan Sanction Letter</option>
                    <option>Amortization Table/Schedule</option>
                    </select>
                    </div>
                    <div className="mb-2">
                    <label className="label"> Document No. <span className="text-red-600">*</span></label>
                    <div className="sh-seg">
                      {[{ v: '0', l: 'Yes' }, { v: '1', l: 'No' }].map((o) => (
                        <button
                          type="button"
                          key={o.v}
                          className={"sh-seg-opt" + (documentNo === o.v ? " on" : "")}
                          onClick={() => setDocumentNo(o.v)}
                        >
                          {o.l}
                        </button>
                      ))}
                    </div>
                    </div>
                    <div className="mb-2">
                    <label className="label"> Members <span className="text-red-600">*</span></label>
                    <select className='form-control'>
                    <option>All Members</option>
                    </select>
                    </div>
                    <div className="mb-2">
                    <label className="label"> Issue Date <span className="text-red-600">*</span></label>
                    <input
                    type="date"
                    className="form-control"
                    placeholder="Name of Organization"
                    /> 
                    </div>
                    <div className="mb-2">
                    <label className="label"> Expiry Date <span className="text-red-600">*</span></label>
                    <input
                    type="date"
                    className="form-control"
                    placeholder="Name of Organization"
                    /> 
                    </div>
                    </div>
                    <div className="grid-cols-12 gap-4 mt-2">
                    <div className="mb-2">
                    <label className="label"> Attach document <span className="text-red-600">*</span></label>
                    <input
                    type="file"
                    className="form-control"
                    placeholder="Name of Organization"
                    /> 
                    <small>Valid file types are doc,docx,pdf,bmp,jpg,jpeg,gif,png,ppt,pptx,xls,xlsx,txt. Max size of each file is 2MB</small>
                    </div>
                    </div>
                   </div>
                   <div className='text-center mt-4'>
                   <button type="button" className="btn btn-white mr-3">Save & Add New</button>
                   <button type="submit" className="btn btn-brand">Save</button>
                   </div>
                </div>
        </>
    )
}

export default Documents;



